import { memo, ReactNode } from 'react';
import './patchWaveformData';

interface Props {
  readonly width: number;
  readonly height: number;
  readonly x?: number;
  readonly bgColor?: string;
  readonly debug?: string | false;
  readonly startTs: number;
  readonly duration: number;
  readonly children: ReactNode;
}

export const WaveformEl = memo(function Waveform({
  x = 0,
  bgColor = 'transparent',
  width,
  height,
  debug,
  startTs,
  duration,
  children,
}: Props) {
  return (
    <g
      data-testid="waveform-el"
      data-ts={startTs}
      data-datetime={new Date(startTs).toISOString()}
      data-duration={duration}
      transform={`translate(${x - 1 || 0},0)`}
    >
      {debug && (
        <text y={20} fontSize="14">
          {debug}
        </text>
      )}
      <rect width={width + 2} height={height} fill={bgColor} />
      {children}
    </g>
  );
});
